import { FC } from "react";

import {
	FieldLayout,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";
import { Box } from "@mui/material";
 
interface IEffectiveDateSetupFieldsPanel {}
export const EffectiveDateSetupFieldsPanel: FC<IEffectiveDateSetupFieldsPanel> = ({}) => {
	return (
		<div style={{width:"40%"}}>
			<RHookFormDatePicker
				label="Effective Date"
				name="effectiveDate"
				testId={`maximum`}
				format="M dd, yy"
				labelPosition={LabelPosition.Top}
			/>
		</div>
	);
};
